var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-X"},React.createElement("rect",{"width":"20","height":"20"}))),React.createElement("g",{"id":"X","clipPath":"url(#clip-X)","key":1},React.createElement("g",{"id":"Gruppe_57","data-name":"Gruppe 57","transform":"translate(-1432.457 -239)"},[React.createElement("line",{"id":"Linie_5","data-name":"Linie 5","y1":"12.457","x2":"12.457","transform":"translate(1436.5 242.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"3","key":0}),React.createElement("line",{"id":"Linie_6","data-name":"Linie 6","y1":"12.457","x2":"12.457","transform":"translate(1448.957 242.5) rotate(90)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"3","key":1})]))]);
}

X.displayName = "X";

X.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = X;

X.default = X;
